import React, { useState } from "react";
import { AvistaAppBar } from "@avista/avista-app-bar";
import { AvistaAvatar } from "@avista/avista-avatar";
import { AvistaSnackbar } from "@avista/avista-snackbar";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { useMainContext } from "reducer";
import { SERVER } from "utils/const";
import { navItems } from "./const";
import { NavDrawer } from "./nav-drawer";

export const Layout: React.FC<React.PropsWithChildren> = (props) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  // get reducer from context
  const { state } = useMainContext();

  return (
    <Box>
      <CssBaseline />
      <AvistaAppBar
        children={{
          mainChildrenItems: navItems,
          rightChildren: (
            <AvistaAvatar
              loginServerUrl={SERVER.LOGIN_HOST!}
              myProfileUrl={SERVER.ADMIN_PROFILE_URL!}
            />
          ),
        }}
        options={{
          muiSxStyle: (theme) => ({
            zIndex: theme.zIndex.drawer + 99,
          }),
        }}
      />

      <IconButton
        // variant="circular"
        size="large"
        onClick={() => {
          setIsOpenDrawer(!isOpenDrawer);
        }}
        sx={({ palette }) => ({
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 10000,
          display: { xs: "initial", sm: "none" },
          backgroundColor: palette.primary.main + " !important",
        })}
      >
        <MenuIcon htmlColor="white" />
      </IconButton>

      <NavDrawer
        open={isOpenDrawer}
        onClose={() => {
          setIsOpenDrawer(false);
        }}
        sx={({ zIndex }) => ({ zIndex: zIndex.drawer + 98 })}
      />
      <main>
        <Box sx={({ mixins }) => mixins.toolbar} />

        <Container
          maxWidth="xl"
          sx={{
            width: "95vw",
            maxWidth: "95vw",
            marginTop: 2,
            marginBottom: 2,
          }}
        >
          {props.children}
        </Container>

        <AvistaSnackbar
          isOpen={state.snackbar.isOpen!}
          text={state.snackbar.text!}
          type={state.snackbar.type!}
          handleClose={state.snackbar.handleClose!}
        />

        <Dialog
          open={state.globalAlertDialog.isOpen!}
          onClose={state.globalAlertDialog.handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{state.globalAlertDialog.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {state.globalAlertDialog.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={state.globalAlertDialog.handleCancel}>
              {state.globalAlertDialog.cancelBtnText}
            </Button>
            <Button onClick={state.globalAlertDialog.handleConfirm} autoFocus>
              {state.globalAlertDialog.confirmBtnText}
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </Box>
  );
};
